import { api } from '../../api/client';
import type { RolePermissionsPayload, RolePermissionsResponse } from './types';

export async function getRolePermissions(roleId: string): Promise<RolePermissionsResponse> {
  return api.get<RolePermissionsResponse>(`/api/roles/${roleId}/permissions`);
}

export async function putRolePermissions(
  roleId: string,
  body: RolePermissionsPayload
): Promise<RolePermissionsResponse> {
  return api.put<RolePermissionsResponse>(`/api/roles/${roleId}/permissions`, body);
}
